import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F8F5]" data-testid="auth-loading">
        <div className="animate-spin w-8 h-8 border-3 border-[#7CA63A] border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
